"use client";
import * as React from "react";
const SvgCheckRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.94 9.7 1.62 6.4A.95.95 0 1 0 .28 7.74l4 3.99a.95.95 0 0 0 1.34 0l10.1-10.1A.95.95 0 1 0 14.37.28z" }));
export {
  SvgCheckRound as default
};
